import { fork } from "redux-saga/effects";
import accountSaga from "@modules/account/sagas";
// import appEventsSaga from "@modules/app-events/sagas";
import appSaga from "@modules/app/sagas";
import clientsSaga from "@modules/client/sagas";
import contextSaga from "@modules/context/sagas";
import hierarchySaga from "@modules/hierarchy/sagas";
import employeeSaga from "@modules/employee/sagas";
import graylogSaga from "@modules/graylog/sagas";
import profileSaga from "@modules/profile/sagas";
import reportingSaga from "@modules/reporting/sagas";
import serviceSaga from "@modules/service/sagas";
import dataSaga from "@modules/data/sagas";
import sharedSagas from "@modules/shared/sagas";
import settingsSagas from "@modules/settings/sagas";

export default function* rootSaga() {
  yield fork(accountSaga);
  // yield fork(appEventsSaga);
  yield fork(appSaga);
  yield fork(clientsSaga);
  yield fork(contextSaga);
  yield fork(hierarchySaga);
  yield fork(employeeSaga);
  yield fork(graylogSaga);
  yield fork(profileSaga);
  yield fork(reportingSaga);
  yield fork(serviceSaga);
  yield fork(dataSaga);
  yield fork(sharedSagas);
  yield fork(settingsSagas);
}
